import React from "react";
import V3PriceCard, { V3CoverageBreakdownLine } from "./V3PriceCard";
import { DownloadableFilesT } from "get-life-storybook-ts/lib/components/DownloadableFiles/DownloadableFiles";

interface V3HeroProps {
  translate: (key: string) => string;
  priceAmount: number;
  loading: boolean;
  ctaLabel: string;
  onCtaClick: () => void;
  breakdown: V3CoverageBreakdownLine[];
  startsLabel?: string;
  draftId?: string;
  downloadableFiles?: DownloadableFilesT;
  downloadDocument?: (type: string) => void;
  beforePromoText?: string;
  afterPromoText?: string;
  onPromoClick?: () => void;
  heroCapitalLabel: string;
  heroPriceLabel: string;
  heroSuffix: string;
}

const V3Hero: React.FC<V3HeroProps> = ({
  translate,
  priceAmount,
  loading,
  ctaLabel,
  onCtaClick,
  breakdown,
  startsLabel,
  draftId,
  downloadableFiles,
  downloadDocument,
  beforePromoText,
  afterPromoText,
  onPromoClick,
  heroCapitalLabel,
  heroPriceLabel,
  heroSuffix,
}) => {
  return (
    <section className="upsell-v3__hero">
      <div className="upsell-v3__hero-glow" aria-hidden="true" />
      <div className="upsell-v3__hero-grid">
        <div>
          <div className="upsell-v3__eyebrow">
            {translate("newUpsell.v3.hero.eyebrow")}
          </div>
          <h1 className="upsell-v3__hero-title">
            {translate("newUpsell.v3.hero.sentence.prefix").replace(
              "{capital}",
              heroCapitalLabel
            )}{" "}
            <span className="upsell-v3__hero-price">{heroPriceLabel}</span>{" "}
            <span
              className="upsell-v3__hero-suffix"
              dangerouslySetInnerHTML={{ __html: heroSuffix }}
            />
          </h1>
          <div className="upsell-v3__hero-proof">
            {(["families", "rating", "backed"] as const).map((k) => (
              <div className="upsell-v3__hero-proof-item" key={k}>
                <div className="upsell-v3__hero-proof-value">
                  {translate(`newUpsell.v3.hero.proof.${k}.value`)}
                </div>
                <div className="upsell-v3__hero-proof-label">
                  {translate(`newUpsell.v3.hero.proof.${k}.label`)}
                </div>
              </div>
            ))}
          </div>
        </div>

        <V3PriceCard
          translate={translate}
          amount={priceAmount}
          loading={loading}
          ctaLabel={ctaLabel}
          onCtaClick={onCtaClick}
          breakdown={breakdown}
          startsLabel={startsLabel}
          draftId={draftId}
          downloadableFiles={downloadableFiles}
          downloadDocument={downloadDocument}
          beforePromoText={beforePromoText}
          afterPromoText={afterPromoText}
          onPromoClick={onPromoClick}
        />
      </div>
    </section>
  );
};

export default V3Hero;
